module.exports = __webpack_public_path__ + "static/media/HeatherNuffer.c7f10bb9.jpg";